module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/firstHistoryImage-2d7c48e16643e552b39670aa53b605e0.png";